module.exports = __webpack_public_path__ + "img/Spinner-0.8s-200px.2e23c03d.gif";